import { useRef } from 'react';
import { showToast } from '../toastMessage/ToastMessage';
import Cookies from 'js-cookie';

/**
 * Handles keydown events to allow only digits, a decimal point with up to three digits after it,
 * and specific control keys, but permits alphabetic characters when combined with modifier keys.
 * @param {KeyboardEvent} e - The keyboard event.
 */
export const handleKeyDown = (e) => {
  // Define a regex pattern to match digits, allowing a decimal point with up to three digits after it
  const regex = /^\d*\.?\d{0,3}$/;

  // Check if the key is a control key or a combination with Ctrl, Alt, or Shift
  const isControlKey =
    e.key === 'Backspace' ||
    e.key === 'Delete' ||
    e.key === 'ArrowLeft' ||
    e.key === 'ArrowRight' ||
    e.key === 'Tab' ||
    e.key === 'Enter' ||
    e.key === 'NumpadEnter';

  const isModifierKey = e.ctrlKey || e.altKey || e.shiftKey || e.metaKey;

  // Check the key input and ensure it matches the regex or is a permitted key, or is used with a modifier key
  if (
    !regex.test(e.target.value + e.key) && // Allow digits and decimal point with up to three digits after the decimal
    !isControlKey &&
    !isModifierKey
  ) {
    e.preventDefault(); // Prevent the default action (e.g., key press)
  }
};

// export const validateInteger = (value) => {
//   if (/^[0-9]+$/.text(value)) {
//     e.preventDefault()
//   }
// }

export const OnlyIntegerUptoThreeDigit = (e) => {
  if (!e) return;
  const isModifierKey = e?.ctrlKey || e?.altKey || e?.metaKey;

  const isControlKey = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Enter',
  ].includes(e?.key);

  // Block unwanted characters
  if (e?.key === '-' || e?.key === 'e') {
    e.preventDefault();
    return;
  }

  const input = e?.target;
  const value = input?.value;
  const { selectionStart, selectionEnd } = input;
  const validNumberPattern = /^(\d+(\.\d{0,3})?|\.\d{0,3})$/;

  let nextValue;
  if (selectionStart !== selectionEnd) {
    nextValue =
      value.substring(0, selectionStart) +
      e.key +
      value.substring(selectionEnd);
  } else {
    nextValue =
      value.substring(0, selectionStart) +
      e.key +
      value.substring(selectionStart);
  }

  if (!validNumberPattern.test(nextValue) && !isControlKey && !isModifierKey) {
    e.preventDefault();
    return;
  }
};
export const OnlyIntegerUptoThreeDigitT = (e) => {
  if (!e) return;
  const isModifierKey = e?.ctrlKey || e?.altKey || e?.metaKey;

  const isControlKey = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Enter',
  ].includes(e?.key);

  // Allow minus sign only at the start of the input
  if (e?.key === '-') {
    const input = e?.target;
    const { selectionStart } = input;
    if (selectionStart !== 0) {
      e.preventDefault();
      return;
    }
  }

  // Block 'e' character
  if (e?.key === 'e') {
    e.preventDefault();
    return;
  }

  const input = e?.target;
  const value = input?.value;
  const { selectionStart, selectionEnd } = input;
  // Updated regex to allow negative numbers and up to three decimal places
  const validNumberPattern = /^-?\d*(\.\d{0,3})?$/;

  let nextValue;
  if (selectionStart !== selectionEnd) {
    nextValue =
      value.substring(0, selectionStart) +
      e.key +
      value.substring(selectionEnd);
  } else {
    nextValue =
      value.substring(0, selectionStart) +
      e.key +
      value.substring(selectionStart);
  }

  if (!validNumberPattern.test(nextValue) && !isControlKey && !isModifierKey) {
    e.preventDefault();
    return;
  }
};

export const OnlyIntegerUptoThreeDigitWithoutDecimal = (e) => {
  const isModifierKey = e.ctrlKey || e.altKey || e.shiftKey || e.metaKey;

  // Allowed control keys (Backspace, Delete, Arrow keys, Tab, Enter)
  const isControlKey = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Enter',
  ].includes(e.key);

  // Prevent `-` and other unwanted characters
  if (e.key === '-' || e.key === 'e' || e.key === '.') {
    e.preventDefault();
    return;
  }

  // Allow only numbers and a single decimal point
  const value = e.target.value;
  if (
    !/^[0-9]*\.?[0-9]*$/.test(value + e.key) &&
    !isControlKey &&
    !isModifierKey
  ) {
    e.preventDefault();
  }
};

export const valueLimiterPurity = (e, num = 24) => {
  const isModifierKey = e?.ctrlKey || e?.altKey || e?.metaKey;

  const isControlKey = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Enter',
  ].includes(e?.key);

  if (e?.key === '-' || e?.key === 'e') {
    e.preventDefault();
    return;
  }

  const input = e.target;
  const value = input.value;
  const validNumberPattern = /^\d+$/;
  // Get selection positions
  const { selectionStart, selectionEnd } = input;

  let nextValue;
  if (selectionStart !== selectionEnd) {
    // Replace selected text with the pressed key
    nextValue =
      value.substring(0, selectionStart) +
      e.key +
      value.substring(selectionEnd);
  } else {
    nextValue =
      value.substring(0, selectionStart) +
      e.key +
      value.substring(selectionStart);
  }

  if (!validNumberPattern.test(nextValue) && !isControlKey && !isModifierKey) {
    e.preventDefault();
    return;
  }

  const nextNumber = parseFloat(nextValue);
  if (
    !isNaN(nextNumber) &&
    nextNumber > num &&
    !isControlKey &&
    !isModifierKey
  ) {
    e.preventDefault();
    showToast(`Value cannot be greater than ${num}`, 'warn');
    return;
  }
};
export const valueLimiterPercentage = (e, num = 100) => {
  const isModifierKey = e?.ctrlKey || e?.altKey || e?.metaKey;

  const isControlKey = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Enter',
  ].includes(e?.key);

  if (e?.key === '-' || e?.key === 'e') {
    e.preventDefault();
    return;
  }

  const input = e.target;
  const value = input.value;
  const validNumberPattern = /^(\d+(\.\d{0,3})?|\.\d{0,3})$/;
  // Get selection positions
  const { selectionStart, selectionEnd } = input;

  let nextValue;
  if (selectionStart !== selectionEnd) {
    // Replace selected text with the pressed key
    nextValue =
      value.substring(0, selectionStart) +
      e.key +
      value.substring(selectionEnd);
  } else {
    nextValue =
      value.substring(0, selectionStart) +
      e.key +
      value.substring(selectionStart);
  }

  if (!validNumberPattern.test(nextValue) && !isControlKey && !isModifierKey) {
    e.preventDefault();
    return;
  }

  const nextNumber = parseFloat(nextValue);
  if (
    !isNaN(nextNumber) &&
    nextNumber > num &&
    !isControlKey &&
    !isModifierKey
  ) {
    e.preventDefault();
    showToast(`Value cannot be greater than ${num}`, 'warn');
    return;
  }
};

export const rotateTabWithinForm = (e, firstInputRef, lastInputRef) => {
  if (e.key === 'Tab') {
    // Determine current active element
    const activeElement = document.activeElement;

    // Check if the active element is within the form
    if (
      activeElement &&
      activeElement.closest('form') === e.target.closest('form')
    ) {
      // If we're on the last input field and tab is pressed (forward), focus the first input field
      if (activeElement === lastInputRef.current && !e.shiftKey) {
        e.preventDefault(); // Prevent default tab behavior
        firstInputRef.current.focus();
      }
      // If we're on the first input field and shift+tab is pressed (backward), focus the last input field
      if (activeElement === firstInputRef.current && e.shiftKey) {
        e.preventDefault(); // Prevent default tab behavior
        lastInputRef.current.focus();
      }
    }
  }
};

export const useInputRef = () => {
  const firstInputRef = useRef(null);
  const lastInputRef = useRef(null);
  return { firstInputRef, lastInputRef };
};

export const validateNumericValue = (
  inputValue,
  max_digits,
  decimal_places,
) => {
  const regex = new RegExp(
    `^\\d{1,${max_digits - decimal_places}}(?:\\.\\d{1,${decimal_places}})?$`,
  );

  return regex.test(inputValue);
};
export const validateUserName = (value) => {
  if (!value) {
    return Promise.reject('Please input your username!');
  }
  return Promise.resolve();
};

export const validateEmail = (value) => {
  // if (!value) {
  //   return Promise.reject('Please input a valid email.');
  // }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(value)) {
    return Promise.reject('Please enter a valid email.');
  }

  return Promise.resolve();
};

export const validateBarCodePrefix = (value) => {
  if (!value) {
    return Promise.reject('Please input a valid Barcode.');
  }
  const barCodePrefix = /^[A-Z0-9$&+,:;=?@#|'<>.-^*()%!]*$/;
  if (!barCodePrefix.test(value)) {
    return Promise.reject(
      'Barcode cannot have numeric characters and should be in uppercase',
    );
  }
  return Promise.resolve();
};

export const validateBarCodePrefixWithDash = (value) => {
  if (!value) {
    return Promise.reject('Please input a valid Barcode.');
  }
  // const barCodePrefix = /^[A-Z0-9$&+,:;=?@#|'<>.-^*()%!]*$/;
  const barCodePrefix = /^[A-Z0-9]+-?$/;

  if (!barCodePrefix.test(value)) {
    return Promise.reject(
      'Barcode cannot have numeric characters and should be in uppercase',
    );
  }
  return Promise.resolve();
};

export const validatePhoneNumber = (field, form, value) => {
  if (!value || value.trim() === '') {
    // No validation for empty values
    return Promise.resolve();
  }
  const numberRegex = /[0-9]/;
  const mobileRegex =
    /^(984|985|986|974|975|976|980|981|982|970|961|962|988)\d{7,15}$/;
  if (!numberRegex.test(value.charAt(value.length - 1))) {
    form.setFieldValue(field.field, value.slice(0, -1));
  }
  if (!mobileRegex.test(value)) {
    return Promise.reject('Please enter a valid mobile number');
  }

  return Promise.resolve();
};

export const validateMobileNumber = (value) => {
  if (!value || value.trim() === '') {
    return Promise.reject('Please enter your mobile Number!');
  }
  const mobileRegex =
    /^(984|985|986|974|975|976|980|981|982|970|961|962|988)\d{7}$/;

  if (!mobileRegex.test(value)) {
    return Promise.reject('Please enter a valid mobile number!');
  }

  return Promise.resolve();
};

/**
 *
 * @param {object} field - The current input field
 * @param {object} form - The form data
 * @param {string} value - The value being entered in the field
 * @returns {Promise}
 */

export const validateFormMobileNumber = (field, form, value) => {
  if (!value || value.trim() === '') {
    return Promise.resolve();
  }
  const numberRegex = /[0-9]/;
  const mobileRegex =
    /^(984|985|986|974|975|976|980|981|982|970|961|962|988)\d{7}$/;
  if (!numberRegex.test(value.charAt(value.length - 1))) {
    form.setFieldValue(field.field, value.slice(0, -1));
  }
  if (!mobileRegex.test(value)) {
    return Promise.reject('Please enter a valid mobile number!');
  }

  return Promise.resolve();
};

export const validatePanNumber = (field, form, value) => {
  if (!value || value.trim() === '') {
    return Promise.resolve();
  }
  const numberRegex = /[0-9]/;
  if (!numberRegex.test(value.charAt(value.length - 1))) {
    form.setFieldValue(field.field, value.slice(0, -1));
  }
  if (!/^\d+$/.test(value)) {
    return Promise.reject('PAN/VAT must contain digits only.');
  } else if (value && value.length !== 9) {
    return Promise.reject('PAN/VAT should contain exactly 9 digits.');
  }
  return Promise.resolve();
};

export const validateMakingCharge = (field, form, value) => {
  const numberRegex = /^\d*\.?\d*$/;
  const makingChargeAmountRegex = /^\d{0,5}(?:\.\d{0,4})?$/;
  if (!numberRegex.test(value.toString().charAt(value.length - 1))) {
    form.setFieldValue(field.field, value.slice(0, -1));
    return Promise.reject('Making Charge must contain digits only');
  }
  if (value && value.toString().startsWith('.')) {
    form.setFieldValue(field.field, value.replace('.', '0.'));
  } else if (value && /^0{2,}/.test(value)) {
    form.setFieldValue(field.field, value.replace(/^0+/, '0'));
  } else if (value && /^0\d+/.test(value)) {
    form.setFieldValue(field.field, value.replace(/^0+/, ''));
  }

  if (form.getFieldValue('makingChargeType') === 'per') {
    if (value > 100) {
      // form.setFieldValue(field.field, value.slice(0, -1));
      return Promise.reject('Percentage should be less than or equal to 100');
    } else {
      return Promise.resolve('');
    }
  } else {
    if (!makingChargeAmountRegex.test(value)) {
      // form.setFieldValue(field.field, value.slice(0, -1));
      return Promise.reject('Making Charge must contain up to 5 digits');
    }
  }
  return Promise.resolve('');
};

export const validateWastageType = (field, form, value) => {
  const numberRegex = /^\d*\.?\d*$/;
  const makingChargeAmountRegex = /^\d{0,3}(?:\.\d{0,3})?$/;
  if (!numberRegex.test(value.toString().charAt(value.length - 1))) {
    form.setFieldValue(field.field, value.slice(0, -1));
    return Promise.reject('Wastage Type must contain digits only');
  }
  if (value && value.toString()?.startsWith('.')) {
    form.setFieldValue(field.field, value.replace('.', '0.'));
  } else if (value && /^0{2,}/.test(value)) {
    form.setFieldValue(field.field, value.replace(/^0+/, '0'));
  } else if (value && /^0\d+/.test(value)) {
    form.setFieldValue(field.field, value.replace(/^0+/, ''));
  }

  if (value > 999) {
    return Promise.reject('Value cannot be greate than 999');
  }
  // if (!makingChargeAmountRegex.test(value)) {
  //   form.setFieldValue(field.field, value.slice(0, -1));
  //   return Promise.reject('Wastage Type must contain up to 3 digits');
  // }

  return Promise.resolve('');
};

export const validatePassword = (value) => {
  if (!value) {
    return Promise.reject('Please input a password.');
  }

  // Regular expression for strong password (minimum 8 characters, at least one uppercase letter, one lowercase letter, one number, and one special character)
  const strongPasswordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  if (!strongPasswordRegex.test(value)) {
    return Promise.reject(
      'Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.',
    );
  }

  return Promise.resolve();
};
export const validateConfirmPassword = (getFieldValue) => (rule, value) => {
  if (value && value !== getFieldValue('password')) {
    return Promise.reject('The two passwords do not match.');
  }

  return Promise.resolve();
};
// validationUtils.js

export const validateDate = (value, setDate, setError) => {
  let dateValue = value;

  // Only allow digits and hyphens
  if (!/^\d{0,4}-?\d{0,2}-?\d{0,2}$/.test(dateValue)) {
    return;
  }

  // Ensure format yyyy-mm-dd while typing
  if (dateValue.length === 4 && !dateValue.includes('-')) {
    dateValue = dateValue + '-';
  } else if (dateValue.length === 7 && dateValue.split('-').length === 2) {
    dateValue = dateValue + '-';
  }

  // Validate individual parts of the date
  const parts = dateValue.split('-');
  if (parts.length > 1 && parts[1] && (parts[1] < '01' || parts[1] > '12')) {
    return;
  }
  if (parts.length > 2 && parts[2] && (parts[2] < '01' || parts[2] > '31')) {
    return;
  }

  setDate(dateValue);

  // Final validation for complete date
  const dateRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
  if (dateRegex.test(dateValue)) {
    setError('');
  } else if (dateValue.length === 10) {
    setError('Invalid date format. Please enter a date in yyyy-mm-dd format.');
  } else {
    setError('');
  }
};

export const rules = {
  textOnly: [
    {
      required: true,
      message: 'This field is required!',
    },
    {
      pattern: new RegExp(/^[a-zA-Z\s]+$/),
      message: 'Please enter text only',
    },
  ],
  numberOnly: [
    {
      required: true,
      message: 'This field is required',
    },
    {
      pattern: new RegExp(/^[0-9]+$/),
      message: 'This field must be number only',
    },
  ],
  textAndNumberOnly: [
    {
      required: true,
      message: 'This field is required',
    },
    {
      pattern: new RegExp(/^[a-zA-Z0-9\s]+$/),
      message: 'Only letters and numbers are allowed',
    },
  ],
  required: [
    {
      required: true,
      message: 'This field is required ',
    },
  ],
  panVat: [
    {
      required: true,
      message: 'This field is required',
    },
    {
      pattern: new RegExp(/^[0-9]+$/),
      message: 'Pan/Vat must be number only',
    },
    {
      min: 9,
      message: 'Pan/Vat must be 9 digits',
    },
    {
      max: 9,
      message: 'Pan/Vat must be only consists of 9 digits',
    },
  ],
  Date: [
    {
      required: true,
      message: 'Please enter the date',
    },
    {
      pattern: /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/,
      message: 'Please enter a valid date',
    },
  ],
  phoneNumber: [
    {
      required: true,
      validator: (_, value) => {
        if (!value) {
          return Promise.reject('Please input your phone number.');
        }
        if (!/^\d+$/.test(value)) {
          return Promise.reject('Phone number must contain digits only.');
        }
        return Promise.resolve();
      },
    },
    {
      min: 10,
      message: 'Phone must contain 10 digits',
    },
  ],

  phoneNumberNew: [
    {
      validator: (_, value) => {
        // if (!value) {
        //   return Promise.reject('Please input your phone number.');
        // }

        if (value?.length > 0) {
          if (!/^\d+$/.test(value)) {
            return Promise.reject('Phone number must contain digits only.');
          }
        }
        return Promise.resolve();
      },
    },
    {
      min: 10,
      // message: 'Phone must contain 10 digits',
    },
  ],
  email: [
    {
      required: true,
      validator: (_, value) => {
        if (!value) {
          return Promise.reject('Please input your email.');
        } else if (!/^\S+@\S+\.\S+$/.test(value)) {
          return Promise.reject('Please enter a valid email address.');
        }
        return Promise.resolve();
      },
    },
  ],
};

//Table header filed validation for all the transaction page
export const validateNotEmpty = (value, fieldName) => {
  if (!value || value.trim() === '') {
    return `${fieldName} cannot be empty`;
  }
  return '';
};

export const validateGramAndLalDecimalDigitsT = (
  field,
  form,
  primaryType,
  value,
) => {
  // Updated regex to allow negative numbers
  const primaryLalRegex = /^-?\d{0,6}(?:\.\d{0,1})?$/;
  const primaryGramRegex = /^-?\d{0,6}(?:\.\d{0,3})?$/;

  if (primaryType === 'lal') {
    if (!primaryLalRegex.test(value)) {
      // Handle negative numbers in truncation
      const isNegative = value?.toString().startsWith('-');
      const absValue = value?.toString().replace('-', '');
      const newValue = Number((isNegative ? '-' : '') + absValue.slice(0, -1));
      form.setFieldValue(field?.field, newValue);
    }
  } else if (primaryType === 'gm') {
    if (!primaryGramRegex.test(value)) {
      // Handle negative numbers in truncation
      const isNegative = value?.toString().startsWith('-');
      const absValue = value?.toString().replace('-', '');
      const newValue = Number((isNegative ? '-' : '') + absValue.slice(0, -1));
      form.setFieldValue(field.field, newValue);
    }
  }
  return Promise.resolve('');
};

export const validateGramAndLalDecimalDigits = (
  field,
  form,
  primaryType,
  value,
) => {
  const primaryLalRegex = /^\d{0,6}(?:\.\d{0,1})?$/;
  const primaryGramRegex = /^\d{0,6}(?:\.\d{0,3})?$/;

  if (primaryType === 'lal') {
    if (value < 0 || value === '-') {
      return Promise.reject('');
    }
    if (!primaryLalRegex.test(value)) {
      const numsArray = value?.toString().split('');
      let newValue = numsArray.slice(0, -1).join('');
      form.setFieldValue(field?.field, newValue);
    }
  } else if (primaryType === 'gm') {
    if (value < 0 || value === '-') {
      return Promise.reject('');
    }
    if (!primaryGramRegex.test(value)) {
      const numsArray = value?.toString().split('');
      let newValue = numsArray.slice(0, -1).join('');
      form.setFieldValue(field.field, newValue);
    }
  }
  return Promise.resolve('');
};

export const validateGramAndLalDecimalDigitsOnChange = (field, inputValue) => {
  const lalRegexTest = /^\d{0,6}(?:\.\d{0,1})?$/;
  const gramRegexTest = /^\d{0,6}(?:\.\d{0,3})?$/;

  const primaryCalculationType = Cookies.get('primaryCalculationType');
  let isValid;

  if (primaryCalculationType === 'lal') {
    isValid =
      field === 'grossWeight'
        ? lalRegexTest.test(inputValue)
        : gramRegexTest.test(inputValue);
  } else if (primaryCalculationType === 'gm') {
    isValid =
      field === 'grossWeight'
        ? gramRegexTest.test(inputValue)
        : lalRegexTest.test(inputValue);
  }
  // Sanitize input
  if (inputValue && inputValue.startsWith('.')) {
    inputValue = inputValue.replace('.', '0.');
  } else if (inputValue && /^0{2,}/.test(inputValue)) {
    inputValue = inputValue.replace(/^0+/, '0');
  } else if (inputValue && /^0\d+/.test(inputValue)) {
    inputValue = inputValue.replace(/^0+/, '');
  }
  return { isValid, inputValue };
};

export const validateGramAndLalDecimalDigitsOnChangeN = (field, inputValue) => {
  // Updated regex to allow optional negative sign
  const lalRegexTest = /^-?\d{0,6}(?:\.\d{0,1})?$/;
  const gramRegexTest = /^-?\d{0,6}(?:\.\d{0,3})?$/;

  const primaryCalculationType = Cookies.get('primaryCalculationType');
  let isValid;

  // Run validation based on field and type
  if (primaryCalculationType === 'lal') {
    isValid =
      field === 'grossWeight'
        ? lalRegexTest.test(inputValue)
        : gramRegexTest.test(inputValue);
  } else if (primaryCalculationType === 'gm') {
    isValid =
      field === 'grossWeight'
        ? gramRegexTest.test(inputValue)
        : lalRegexTest.test(inputValue);
  }

  // Sanitize input
  if (inputValue && inputValue.startsWith('.')) {
    inputValue = inputValue.replace('.', '0.');
  } else if (inputValue && /^-?\.\d*$/.test(inputValue)) {
    inputValue = inputValue.replace('.', '-0.');
  } else if (inputValue && /^-?0{2,}/.test(inputValue)) {
    inputValue = inputValue.replace(/^(-?)0+/, '$10');
  } else if (inputValue && /^-?0\d+/.test(inputValue)) {
    inputValue = inputValue.replace(/^(-?)0+/, '$1');
  }

  return { isValid, inputValue };
};

export const amountValidation = (inputValue) => {
  const isValid = /^(\d+\.?\d{0,3}|\.\d{0,3})?$/.test(inputValue);

  // Sanitize input
  if (inputValue && inputValue.startsWith('.')) {
    inputValue = inputValue.replace('.', '0.');
  } else if (inputValue && /^0{2,}/.test(inputValue)) {
    inputValue = inputValue.replace(/^0+/, '0');
  } else if (inputValue && /^0\d+/.test(inputValue)) {
    inputValue = inputValue.replace(/^0+/, '');
  }
  return { isValid, inputValue };
};

export const weightValidation = (inputValue) => {
  const lalRegexTest = /^(\d{0,5}(\.\d{0,1})?|\.\d{0,1})?$/;
  const gramRegexTest = /^(\d{0,5}(\.\d{0,3})?|\.\d{0,3})?$/;

  if (typeof inputValue !== 'string') inputValue = inputValue?.toLocaleString();
  const primaryCalculationType = Cookies.get('primaryCalculationType');
  // Sanitize input
  if (inputValue && inputValue.startsWith('.')) {
    inputValue = inputValue.replace('.', '0.');
  } else if (inputValue && /^0{2,}/.test(inputValue)) {
    inputValue = inputValue.replace(/^0+/, '0');
  } else if (inputValue && /^0\d+/.test(inputValue)) {
    inputValue = inputValue.replace(/^0+/, '');
  }

  const isValid =
    primaryCalculationType === 'lal'
      ? lalRegexTest.test(inputValue)
      : gramRegexTest.test(inputValue);

  // inputValue = parseFloat(inputValue)

  return { isValid, inputValue };
};

export const weightValidationDiamondCarat = (inputValue, unit) => {
  const lalRegexTest = /^(\d{0,5}(\.\d{0,1})?|\.\d{0,1})?$/;
  const gramRegexTest = /^(\d{0,5}(\.\d{0,3})?|\.\d{0,3})?$/;

  if (typeof inputValue !== 'string') inputValue = inputValue?.toLocaleString();
  if (inputValue && inputValue.startsWith('.')) {
    inputValue = inputValue.replace('.', '0.');
  } else if (inputValue && /^0{2,}/.test(inputValue)) {
    inputValue = inputValue.replace(/^0+/, '0');
  } else if (inputValue && /^0\d+/.test(inputValue)) {
    inputValue = inputValue.replace(/^0+/, '');
  }

  const isValid =
    unit === 'lal'
      ? lalRegexTest.test(inputValue)
      : gramRegexTest.test(inputValue);

  return { isValid, inputValue };
};

export const weightValidationT = (inputValue) => {
  // Updated regex to allow an optional negative sign at the start
  const lalRegexTest = /^-?(\d{0,5}(\.\d{0,1})?|\.\d{0,1})?$/;
  const gramRegexTest = /^-?(\d{0,5}(\.\d{0,3})?|\.\d{0,3})?$/;

  // Convert input to string if it isn't already
  if (typeof inputValue !== 'string') {
    inputValue = inputValue?.toString();
  }

  const primaryCalculationType = Cookies.get('primaryCalculationType');

  // Sanitize input
  if (inputValue) {
    // Handle negative numbers and decimal points
    if (inputValue.startsWith('-.')) {
      inputValue = inputValue.replace('-.', '-0.');
    } else if (inputValue.startsWith('.')) {
      inputValue = inputValue.replace('.', '0.');
    }

    // Handle leading zeros for positive and negative numbers
    if (inputValue.startsWith('-0') && !inputValue.startsWith('-0.')) {
      inputValue = inputValue.replace(/^-0+/, '-0');
    } else if (inputValue.startsWith('0') && !inputValue.startsWith('0.')) {
      inputValue = inputValue.replace(/^0+/, '0');
    } else if (inputValue.startsWith('-0') && !inputValue.startsWith('-0.')) {
      inputValue = inputValue.replace(/^-0+/, '-0');
    } else if (inputValue.match(/^-\d+/) && !inputValue.startsWith('-0.')) {
      inputValue = inputValue.replace(/^-0+/, '-');
    } else if (inputValue.match(/^0\d+/)) {
      inputValue = inputValue.replace(/^0+/, '');
    }
  }

  // Validate input based on calculation type
  const isValid =
    primaryCalculationType === 'lal'
      ? lalRegexTest.test(inputValue)
      : gramRegexTest.test(inputValue);

  // Parse the sanitized input to a number for calculations
  const parsedValue =
    inputValue && isValid ? parseFloat(inputValue) : inputValue;

  return { isValid, inputValue, parsedValue };
};

// handle paste event for weight
export const handlePaste = (e, field, handleFieldChange) => {
  e.preventDefault();
  const primaryCalculationType = Cookies.get('primaryCalculationType');
  const pastedValue = e?.clipboardData?.getData('text');
  let unit = primaryCalculationType;
  if (field?.toLowerCase()?.includes('gm')) {
    unit = primaryCalculationType === 'lal' ? 'gm' : 'lal';
  }
  const formattedValue = Number(
    parseFloat(pastedValue).toFixed(unit === 'lal' ? 1 : 3),
  );
  if (!isNaN(formattedValue)) {
    handleFieldChange(field, formattedValue);
  } else {
    handleFieldChange(field, 0);
  }
};
